import { Pagination as AntdPagination, Col, Row, Select } from 'antd';
import type { PaginationProps as AntdPaginationProps } from 'antd';
import classNames from 'classnames';

import './Pagination.scss';

const { Option } = Select;

type OmittedProps = 'pageSizeOptions' | 'showSizeChanger';

interface PaginationProps extends Omit<AntdPaginationProps, OmittedProps> {
    pageSizeLabel?: string;
    pageSizeOptions: number[];
    onPageSizeChange: (newPageSize: number) => void;
}

const Pagination = ({
    className,
    pageSize,
    pageSizeLabel = 'Items per page',
    pageSizeOptions,
    onPageSizeChange,
    ...props
}: PaginationProps): JSX.Element => {
    const showOptionLabel = (option: number): string =>
        option === Number.MAX_SAFE_INTEGER ? 'All' : option.toString();

    return (
        <Row className={classNames('pagination', className)} align="bottom" gutter={8}>
            <AntdPagination size="small" pageSize={pageSize} {...props} />
            <Col>
                <label className="pagination__select-label">{pageSizeLabel}</label>
                <Select
                    className="pagination__select"
                    defaultValue={pageSize}
                    onChange={(newPageSize) => onPageSizeChange(newPageSize)}
                >
                    {pageSizeOptions.map((option) => (
                        <Option key={option} value={option}>
                            {showOptionLabel(option)}
                        </Option>
                    ))}
                </Select>
            </Col>
        </Row>
    );
};

export default Pagination;
